export default __webpack_public_path__ + "static/media/test.6488e8d5.PNG";